import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    CreateOrUpdateUserTokenInput,
    CreateOrUpdateUserTokenMutationResponse,
} from "@/Domains/AuthenticationManagement/Usertoken/Mutations/__generated__/CreateOrUpdateUserTokenMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: CreateOrUpdateUserTokenInput,
    onCompleted: (error: Error | null, result?: boolean) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation CreateOrUpdateUserTokenMutation($input: CreateOrUpdateUserTokenInput!) {
                createUserWithToken(input: $input)
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as CreateOrUpdateUserTokenMutationResponse;

            if (res) {
                onCompleted(null, true);
                return;
            }

            throw new BaseError(
                "CreateOrUpdateUserTokenMutation failed with an unexpected Error",
                {},
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
